<template>
    <tr>
        <td v-for="i in emptyCellsBefore" :key="i" />
        <td
            v-for="(label, index) in labels"
            :key="index + '_filter'"
            class="filter"
        >
            <component
                :is="`filter-${label.type || 'string'}`"
                v-if="label.filterable !== false"
                :options="label.enumOptions"
                :is-enum-option-labeled="label.isEnumOptionLabeled"
                :default="
                    initFilters[label.filterFieldName || label.value || label]
                "
                @filter-change="onFilterChange($event, label)"
            />
            <i v-else class="fas fa-ban" />
        </td>
    </tr>
</template>

<script>
import FilterBoolean from './filters/Boolean';
import FilterNumber from './filters/Number';
import FilterString from './filters/String';
import FilterEnum from './filters/Enum';
import FilterDate from './filters/Date';

export default {
    components: {
        FilterBoolean,
        FilterNumber,
        FilterString,
        FilterDate,
        FilterEnum
    },

    props: {
        labels: {
            type: Array,
            required: false,
            default: () => []
        },
        initFilters: {
            type: Object,
            required: false,
            default: () => ({})
        },
        emptyCellsBefore: {
            type: Number,
            required: false,
            default: 0
        }
    },

    data() {
        return {
            filters: {}
        };
    },

    created() {
        this.filters = { ...this.initFilters };
    },

    methods: {
        onFilterChange(filter, label) {
            const property = label.filterFieldName || label.value || label;

            if (filter.value || filter.value === 0) {
                this.filters[property] = filter;
            } else {
                delete this.filters[property];
            }

            this.$emit('filter-change', this.filters);
        }
    }
};
</script>
